<header class="header-wrapper">
  <au-header-menu [showOnlyDesktop]="showOnlyDesktop"></au-header-menu>

  <div class="flex align-items-center gap-3">
    @if (showSandboxProfilePanel) {
      <div class="sandbox-profile-panel">
        <div class="panel-user subtitle-small text-secondary">
          {{ currentUserProfile?.email || '-' }}
        </div>

        <div class="panel-meta body-small text-tertiary">
          <div class="panel-row">
            <span class="panel-value">
              {{ currentUserProfile?.customer?.id || '-' }} -
              {{ currentUserProfile?.customer?.name || '-' }}
            </span>
          </div>

          <div class="panel-row">
            <span class="panel-value">
              {{
                currentUserProfile?.accessLevels?.length
                  ? currentUserProfile?.accessLevels?.join(', ')
                  : '-'
              }}
            </span>
          </div>
        </div>
      </div>
    }

    <!-- Email & Call Buttons -->
    <div class="flex align-items-center gap-2 contact-actions">
      <button
        pButton
        type="button"
        class="p-button-rounded contact-btn email-btn"
        [pTooltip]="'Email<br>' + squadInfo?.email"
        tooltipPosition="bottom"
        tooltipStyleClass="multi-line-tooltip"
        [escape]="false"
        (click)="sendEmail()"
      >
        <i class="pi pi-envelope" pButtonIcon></i>
      </button>

      <button
        pButton
        type="button"
        class="p-button-rounded contact-btn call-btn"
        [pTooltip]="
          'Call<br>+' +
          squadInfo?.phone?.phoneCountryCode +
          '-' +
          squadInfo?.phone?.phoneNumber
        "
        tooltipPosition="bottom"
        tooltipStyleClass="multi-line-tooltip"
        [escape]="false"
        (click)="callNumber()"
      >
        <i class="pi pi-phone" pButtonIcon></i>
      </button>
    </div>

    @if (isChatButtonVisible) {
      <div
        id="chat-launcher-btn"
        class="flex align-items-center justify-content-center gap-2 chat-button-container"
        [ngClass]="showOnlyDesktop ? 'desktop-container' : ''"
        (click)="openChatWidget($event)"
      >
        <div class="image-container">
          <img
            [src]="squadPicturePath"
            alt="Picture of squad member"
            class="chat-button-image"
          />
          <div class="online-icon"></div>
        </div>
        @if (showOnlyDesktop) {
          <div class="flex flex-column">
            <span class="text-placeholder chat-with-text">Chat with</span>
            <span class="text-primary button-text-medium">{{ squadName }}</span>
          </div>
        }
      </div>
    }

    <div class="user-profile-wrapper">
      <p-menu #menu [model]="items" [popup]="true" appendTo="body"></p-menu>
      <button
        class="subtitle-small text-secondary user-profile-button"
        pButton
        type="button"
        (click)="menu.toggle($event)"
      >
        <span class="user-avatar">
          {{ userAvatar }}
        </span>
      </button>
    </div>
  </div>
</header>

@if (showChangePassword) {
  <au-change-password [(toggleChangePassword)]="showChangePassword">
  </au-change-password>
}

@if (showContactSupport) {
  <au-support [(toggleModal)]="showContactSupport"> </au-support>
}
